<template>
  <div class="q-pa-md">
    <q-table
      hide-bottom
      dense
      title="Innevarande månad"
      square
      :rows-per-page-options="[0]"
      :rows="rows"
      :columns="columns"
      class="dailyReportTrafficTable"
      separator="cell"
      :bordered="isPrintMode"
      :flat="isPrintMode"
    >
      <template v-slot:header-cell="props">
        <q-th :props="props">
          <div :style="props.col.style">
            {{ props.col.label }}
          </div>
        </q-th>
      </template>

      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td
            key="punctualityShuttle"
            :props="props"
            style="white-space: pre-wrap"
          >
            {{ props.row?.punctualityShuttle }}
          </q-td>
          <q-td
            key="punctualityRegion"
            :props="props"
            style="white-space: pre-wrap"
          >
            {{ props.row?.punctualityRegion }}
          </q-td>
          <q-td key="deviatingCrew" :props="props">
            {{ props.row?.deviatingCrew }}
          </q-td>
          <q-td key="deviations" :props="props">
            {{ props.row?.deviations }}
          </q-td>
          <q-td key="withdrawn" :props="props">
            {{ props.row?.withdrawn }}
          </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useDailyReport } from '@/composable/useDailyReport'
import { useProfile } from '@/composable/useProfile'

export default defineComponent({
  name: 'DailyReportSummaryTable',

  setup() {
    const { isPrintMode, data } = useDailyReport()
    const { currentProject } = useProfile()
    // const colStyle = 'white-space: pre-wrap'
    const columns = [
      {
        align: 'left',
        name: 'punctualityShuttle',
        label: 'Helt inställda tåg',
        field: 'punctualityShuttle',
      },
      {
        align: 'left',
        name: 'punctualityRegion',
        label: 'Delvis inställda tåg',
        field: 'punctualityRegion',
      },

      {
        align: 'left',
        name: 'deviatingCrew',
        label: 'Korta tåg',
        field: 'deviatingCrew',
        style: '',
      },

      {
        align: 'left',
        name: 'deviations',
        label: 'Slopade uppehåll',
        field: 'deviations',
        style: '',
      },
    ]

    const rows = computed(() => {
      return [
        {
          punctualityShuttle: data.value.summary.rows
            .find((x) => x.label === 'Helt inställda tåg')
            ?.data.find((t) => t.name === 'Helt inställda tåg')?.count,
          punctualityRegion: data.value.summary.rows
            .find((x) => x.label === 'Delvis inställda tåg')
            ?.data.find((t) => t.name === 'Delvis inställda tåg')?.count,
          shortTrain: data.value.summary.rows
            .find((x) => x.label === 'Korta tåg')
            ?.data.find((t) => t.name === 'Korta tåg')?.count,
          deviations: data.value.summary.rows
            .find((x) => x.label === 'Slopade uppehåll')
            ?.data.find((t) => t.name === 'Slopade uppehåll')?.count,
        },
      ]
    })

    return { rows, columns, isPrintMode, currentProject }
  },
})
</script>

<style lang="scss">
.dailyReportTrafficTable {
  .q-table__top {
    background-color: #00a540;
    color: white;
  }

  thead tr:first-child th {
    background-color: #00a540;
    color: white;
  }
}
</style>

<style lang="scss" module>
.totalRow {
  background-color: rgba(#00a540, 0.1);
  font-weight: 600;
}
</style>
